import { Stack, Typography } from 'src/components/mui';
//@ts-ignore
import React from 'react';
import { Box } from '@mui/material';

type Props = {
  src: string;
  label: string;
};

export function Tip({ src, label }: Props) {
  return (
    <Stack spacing={2} alignItems="center">
      <Box component="img" margin="auto" src={src} minHeight="70px" sx={{ objectFit: 'none' }} />
      <Typography sx={{ typography: { sm: 'body1', xs: 'body2' }, color: '#fff' }}>
        {label}
      </Typography>
    </Stack>
  );
}
